import { jsx as o } from "react/jsx-runtime";
import { useAssets as s } from "@dcentralexpedientedigital/fe-cms-api/hooks/use-assets";
const l = ({ src: r, className: t }) => {
  const { isLoading: e, data: n } = s({ id: r });
  return e || !n ? null : /* @__PURE__ */ o(
    "div",
    {
      className: t,
      dangerouslySetInnerHTML: {
        __html: n ?? ""
      }
    }
  );
};
export {
  l as InlineSvg
};
